// 退货入库初检的逐件判定（前端预览用）：和后端 rule_lookup_service.decide() 保持一致。
// 真正的判定在服务端做（提交时重新计算，不信任前端结论）；这里只是让仓库边填边看到每件的结果。
import type { DecisionFlow, FlowBranch, RuleMode } from '../types/returnInspection';

export type PieceResult = 'resell' | 'aiu' | 'destroy';

export const PIECE_RESULT_LABEL: Record<PieceResult, string> = {
  resell: '正常品入库',
  aiu: '异常品入库',
  destroy: '销毁',
};

interface RuleLike {
  mode: RuleMode;
  decision_flow: DecisionFlow | Record<string, never>;
}

const branchOf = (rule: RuleLike, appearance: boolean): FlowBranch | undefined =>
  (rule.decision_flow as DecisionFlow)?.[appearance ? 'appearance_ok' : 'appearance_bad'];

/** 外观检查之后，流程是否要求继续检查内件（外观结果还没填时返回 false） */
export const needsContentCheck = (rule: RuleLike, appearance: boolean | null | undefined): boolean => {
  if (rule.mode !== 'conditional' || appearance === null || appearance === undefined) return false;
  return branchOf(rule, appearance)?.action === 'continue';
};

/**
 * 判定一件的结果。信息不全（外观没填，或需要内件结果但没填）返回 null。
 * 一律销毁 / 一律AIU 的规则不需要任何检查。
 */
export const decidePiece = (
  rule: RuleLike,
  appearance: boolean | null | undefined,
  content: boolean | null | undefined,
): { result: PieceResult; contentChecked: boolean } | null => {
  if (rule.mode === 'always_destroy') return { result: 'destroy', contentChecked: false };
  if (rule.mode === 'always_aiu') return { result: 'aiu', contentChecked: false };
  if (appearance === null || appearance === undefined) return null;
  const branch = branchOf(rule, appearance);
  if (!branch) return null;
  if (branch.action !== 'continue') return { result: branch.action as PieceResult, contentChecked: false };
  if (content === null || content === undefined) return null;
  return { result: (content ? branch.content_ok : branch.content_bad) as PieceResult, contentChecked: true };
};
